import LesaPurchaseSummaryItineraryDates
  from 'supportAssistant/components/SelectPurchase/LesaPurchaseSummary/Common/LesaPurchaseSummaryItineraryDates'
import { RESERVATION_STATE_PENDING } from 'constants/reservation'
import React from 'react'
import { ITEM_STATUS_AWAITING_DATES, ORDER_STATUS_COMPLETED } from 'constants/cart'

interface Props {
  order: App.Order;
  item: App.OrderItem;
  isTour: boolean;
}

export default function LesaHotelPurchaseItem({ item, isTour, order }: Props) {
  let status: string = item.status

  if (isTour && item.reservation) {
    if (item.onHold) {
      status = ITEM_STATUS_AWAITING_DATES
    } else if (order.status === ORDER_STATUS_COMPLETED && item.reservation.state === RESERVATION_STATE_PENDING) {
      status = RESERVATION_STATE_PENDING
    } else if (item.reservation.travellerDetailsRequired) {
      status = 'needsDetails'
    }
  }

  return <LesaPurchaseSummaryItineraryDates
    key={item.id}
    status={status}
    showReservationDates={!item.onHold && item.reservation && item.reservation.state !== RESERVATION_STATE_PENDING}
    startDate={item.reservation?.startDate}
    endDate={item.reservation?.endDate}
    duration={item.duration ? (item.duration && item.durationLabel) : undefined}
    bookingNumber={item.bookingNumber}
  />
}
